import Swiper from 'swiper';

export function VerificationProcessSlider() {
    new Swiper(".verification-process-slider", {
        freeMode: true,
        grabCursor: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 4,
            }
        }
    });
}

